/* =====================================================================================================================
   batida-v7-clarity.js (5.10.2026): batida.pl changes after the first Clarity review, approved by Aleksandra on 5.10
   (outputs/2026-10-05-clarity/WDROZENIE-0510.md). One block per item, each with its own revert note. Loaded (defer)
   by layout/theme.liquid on batida.pl only.
   ===================================================================================================================== */
(function () {
  'use strict';
  if (!document.documentElement.classList.contains('v7')) return;
  function ready(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  ready(function () {
    /* blocks are added below, one per Clarity item */

    /* ---------- Clarity 5a + 5b: menu items that looked dead ----------
       Clarity saw repeated taps on "Zamów na jutro · realizacja 24 h" and on the "Nowości · Piątek w biurze" group in the
       "Menu" dropdown and the phone menu. The links work, but nothing on screen answered the tap while the next page
       loaded, and a tap between the pills or on the word "Nowości" hit no link at all. Now:
       - a tapped menu link answers at once (class is-going: pressed look + a small spinner, CSS in batida-v7-clarity.css);
       - a tap on the "Nowości" label opens its first pill ("Piątek w biurze"); a tap in the gap of a menu list opens the
         link nearest to the tap.
       Revert: delete this block and its CSS. */
    var MENU_LINKS = '.v7-mega a.navlink, .v7-pm a.v7-pm__it, .v7-pm a.v7-pm__row, a.v7-news__a';
    var MENU_GROUPS = '.v7-news, .v7-mega, .v7-pm__list';
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var t = e.target;
      if (!t || !t.closest) return;
      var a = t.closest(MENU_LINKS);
      if (!a) {
        var g = t.closest(MENU_GROUPS);
        if (!g || t.closest('a, button, input, summary, label')) return;
        var links = Array.prototype.slice.call(g.querySelectorAll(g.classList.contains('v7-news') ? 'a.v7-news__a' : MENU_LINKS))
          .filter(function (l) { return l.offsetParent !== null; });
        if (!links.length) return;
        if (t.closest('.v7-news__t')) a = links[0];
        else {
          var best = null, bd = 1e9;
          links.forEach(function (l) {
            var r = l.getBoundingClientRect();
            var dx = Math.max(r.left - e.clientX, 0, e.clientX - r.right), dy = Math.max(r.top - e.clientY, 0, e.clientY - r.bottom);
            var d = dx * dx + dy * dy;
            if (d < bd) { bd = d; best = l; }
          });
          if (!best || bd > 40 * 40) return;   // only a near miss, not a tap anywhere in the panel
          a = best;
        }
        e.preventDefault();
        a.classList.add('is-going');
        window.location.href = a.href;
        return;
      }
      if (a.target === '_blank') return;
      a.classList.add('is-going');
    }, true);
    /* ---------- Clarity 5c: O nas photos open larger ----------
       On /pages/o-nas people tapped the history photos ("Rodzina Radziszewskich", "Jadwiga, Jolanta i Carolina"): they
       zoom on hover, so they look like they open. Now a tap opens the photo large over the page (its alt text as the
       caption); a tap anywhere, the X or Esc closes it. Text and headings stay plain text. Revert: delete this block. */
    var onas = document.querySelector('.v7o');
    if (onas) {
      onas.querySelectorAll('.v7h-ph:not(.v7-ph-hidden) img').forEach(function (img) {
        var box = img.closest('.v7h-ph');
        if (img.closest('a, button') || !box) return;
        box.classList.add('v7cl-zoom');
        box.setAttribute('role', 'button');
        box.setAttribute('tabindex', '0');
        box.setAttribute('aria-label', (img.getAttribute('alt') || '').trim() || 'Powiększ zdjęcie');
      });
      var lb = null;
      function closeLb() { if (lb) { lb.remove(); lb = null; document.documentElement.style.overflow = ''; } }
      function openLb(box) {
        var img = box.querySelector('img'); if (!img) return;
        var src = img.currentSrc || img.src;
        var big = src.replace(/([?&])width=\d+/, '$1width=1600');
        lb = document.createElement('div');
        lb.className = 'v7cl-lb';
        lb.setAttribute('role', 'dialog');
        lb.setAttribute('aria-modal', 'true');
        var alt = (img.getAttribute('alt') || '').trim();
        lb.innerHTML = '<button type="button" class="v7cl-lb__x" aria-label="Zamknij">&times;</button><figure class="v7cl-lb__f"><img alt=""><figcaption></figcaption></figure>';
        lb.querySelector('img').src = big;
        lb.querySelector('img').alt = alt;
        lb.querySelector('figcaption').textContent = alt;
        lb.addEventListener('click', closeLb);
        document.body.appendChild(lb);
        document.documentElement.style.overflow = 'hidden';
        lb.querySelector('.v7cl-lb__x').focus();
      }
      onas.addEventListener('click', function (e) { var b = e.target.closest && e.target.closest('.v7cl-zoom'); if (b) { e.preventDefault(); openLb(b); } });
      onas.addEventListener('keydown', function (e) { var b = e.target.closest && e.target.closest('.v7cl-zoom'); if (b && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); openLb(b); } });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLb(); });
    }

    /* ---------- Clarity 7.10 (Aleksandra 19:39): the cart icon "+" on product tiles ----------
       Clarity counted 41 dead clicks on it (5-7.10, Ciasta i torty). It was a plain form: a tap posted to /cart/add and
       Shopify then loaded the whole /cart page - seconds with nothing on screen, so people tapped again or gave up.
       Now the tap adds the product in the background (/cart/add.js), the icon shows a tick at once, the header counter
       goes up and a small bar "Dodano do koszyka · Zobacz koszyk" appears. If Shopify refuses (sold out, a required
       choice), the product page opens instead; on a network error the old form post runs.
       Revert: delete this block and its CSS (.v7cl-qa*). */
    var QA_T = ({
      pl: ['Dodano do koszyka', 'Zobacz koszyk', 'Dodaję…'],
      en: ['Added to basket', 'View basket', 'Adding…'],
      de: ['In den Warenkorb gelegt', 'Zum Warenkorb', 'Wird hinzugefügt…'],
      fr: ['Ajouté au panier', 'Voir le panier', 'Ajout…'],
      uk: ['Додано до кошика', 'Переглянути кошик', 'Додаю…']
    })[(document.documentElement.lang || 'pl').slice(0, 2)] || ['Dodano do koszyka', 'Zobacz koszyk', 'Dodaję…'];
    var QA_ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var qaBar = null, qaTimer = 0;
    function qaToast() {
      if (!qaBar) {
        qaBar = document.createElement('div');
        qaBar.className = 'v7cl-qa-bar'; qaBar.setAttribute('role', 'status'); qaBar.setAttribute('aria-live', 'polite');
        document.body.appendChild(qaBar);
      }
      qaBar.innerHTML = '<span>✓ ' + QA_T[0] + '</span><a href="' + QA_ROOT + 'cart?ref=dodano">' + QA_T[1] + ' →</a>';
      qaBar.classList.add('is-on');
      clearTimeout(qaTimer); qaTimer = setTimeout(function () { qaBar.classList.remove('is-on'); }, 5000);
    }
    function qaCount() {
      fetch(QA_ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          document.querySelectorAll('[data-header-cart-count]').forEach(function (el) { el.setAttribute('data-header-cart-count', c.item_count); el.textContent = c.item_count; });
          document.dispatchEvent(new CustomEvent('batida:cart-updated', { detail: c }));
        }).catch(function () {});
    }
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.classList || !f.classList.contains('v7-card__quick') || !window.fetch) return;
      var btn = f.querySelector('.v7-card__qbtn');
      // 7.10 (Aleksandra 20:06: one tap added Tarta malinowa x2): where the cart drawer (assets/batida-drawer.js) is loaded it
      // already adds in the background and opens the drawer - then only the instant tick + Clarity event, never a second add.
      if (window.__batidaDrawerLoaded) {
        if (btn) { btn.classList.add('is-added'); setTimeout(function () { btn.classList.remove('is-added'); }, 2500); }
        if (window.clarity) { try { clarity('event', 'quick_add'); } catch (x) {} }
        return;
      }
      e.preventDefault();
      if (btn && btn.classList.contains('is-adding')) return;
      if (btn) { btn.classList.add('is-adding'); btn.setAttribute('aria-busy', 'true'); }
      var id = f.querySelector('input[name="id"]'), q = f.querySelector('input[name="quantity"]');
      var link = f.closest('.v7-card') && f.closest('.v7-card').querySelector('a.v7-card__cta, a.v7-card__name');
      fetch(QA_ROOT + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: +(id && id.value), quantity: +(q && q.value) || 1 }] })
      }).then(function (r) {
        if (btn) { btn.classList.remove('is-adding'); btn.removeAttribute('aria-busy'); }
        if (r.ok) {
          if (btn) { btn.classList.add('is-added'); setTimeout(function () { btn.classList.remove('is-added'); }, 2500); }
          qaToast(); qaCount();
          if (window.clarity) { try { clarity('event', 'quick_add'); } catch (x) {} }
        } else if (link) { location.href = link.href; } else { f.submit(); }
      }).catch(function () { if (btn) btn.classList.remove('is-adding'); f.submit(); });
    }, true);

    /* back/forward cache: a page restored from history must not keep the spinner */
    window.addEventListener('pageshow', function () {
      document.querySelectorAll('.is-going').forEach(function (l) { l.classList.remove('is-going'); });
    });
  });
})();
